module.exports = __webpack_public_path__ + "img/diamond-lv2.77d35885.png";